<template>
  <div class="ticketlist">
    <div class="headerImage">
      <img src="~@/assets/image/common/common_header.png" alt="" />
    </div>
    <state v-if="$store.state.ticketResources.length" :resourcesObj="resourcesObj"></state>
    <selector select="selector-about"></selector>
    <router-view></router-view>
  </div>
</template>

<script>
import state from "@/components/entry/buyTicketHome/state/index.vue";
import policyNotice from "@/components/entry/buyTicketHome/policyNotice/index.vue";
import selector from "@/components/entry/buyTicketHome/selector/index.vue";
import { getResourceList } from '@/service/future/future.js';

export default {
  name: "nry",
  data(){
    return {
      resourcesObj: null
    }
  },
  created(){
    this.initializationTicketResources();
  },
  methods: {
    initialization() {
      this.$store.commit("setIndividualticketlist", "/nry");
    },
    async initializationTicketResources(){
      const result = await getResourceList.call(this, {
        ticketIdList: ['125']
      });
      this.resourcesObj = result.data[0];
    },
  },
  components: {
    state,
    selector,
    policyNotice,
  },
};
</script>

<style scoped lang='less'>
.ticketlist{
  background: #9D6C29;
}
</style>
